import { render, staticRenderFns } from "./Set_database.vue?vue&type=template&id=4c67a054"
import script from "./Set_database.vue?vue&type=script&lang=js"
export * from "./Set_database.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports